import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import {
  registrationFieldUpdate,
  postEventContactFieldValidate,
  checkAccountExists,
  contractSubmit,
  setRole,
} from "redux/ducks/Registration";
import PhoneInput from 'react-phone-input-2'

const PostEventContact = ({
  history,
  updateField,
  user,
  validateField,
  validation,
  checkAccountExists,
  contractSubmit,
  setRole,
}) => {

  useEffect(() => {
    setRole("EventOperator");
  }, []);

  const onFieldValidate = field => {
    validateField(field);
  };

  const onPrevious = e => {
    e.preventDefault();
    if (user.postEventMasterType === "contract") {
      history.push("/sign-up/contract/info")
    }
  };


  const onNext = e => {
    e.preventDefault();
    if (user.postEventMasterType === "contract") {
      contractSubmit(history);
    }
  };

  const onFieldChange = (field, triggerValidate) => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      updateField(field, ev.currentTarget.value);
      if (triggerValidate) {
        onFieldValidate(field);
      }
    };
  };

  const onPhoneNumberChange = (phone) => {
    const phoneNo = phone.length === 1 && phone.at(0) !== '1' ? `1${phone}` : phone;
    updateField('phone', phoneNo);
    onFieldValidate('phone');
  }

  return (
    <div className="postEventContact">
      <h2>
        Who should we contact about this position?
      </h2>
      <form id="accountForm" noValidate onSubmit={e => e.preventDefault()}>
        <div className="form-group">
          <label className="required" htmlFor="firstName">First Name</label>
          <input
            type="text"
            placeholder="John"
            value={user.firstName}
            className={classnames("form-control", {
              "is-invalid": validation.errors.firstName
            })}
            name="firstName"
            onChange={onFieldChange("firstName")}
            onBlur={onFieldValidate.bind(this, "firstName")}
          />
          <div className="invalid-feedback">{validation.errors.firstName}</div>
        </div>
        <div className="form-group">
          <label className="required" htmlFor="lastName">Last Name</label>
          <input
            type="text"
            placeholder="Snow"
            value={user.lastName}
            className={classnames("form-control", {
              "is-invalid": validation.errors.lastName
            })}
            name="lastName"
            onChange={onFieldChange("lastName")}
            onBlur={onFieldValidate.bind(this, "lastName")}
          />
          <div className="invalid-feedback">{validation.errors.lastName}</div>
        </div>
        <div className="form-group">
          <label className="required" htmlFor="email">Email</label>
          <input
            type="email"
            placeholder="Email"
            value={user.email}
            className={classnames("form-control", {
              "is-invalid": validation.errors.email
            })}
            name="email"
            onChange={onFieldChange("email")}
            onBlur={onFieldValidate.bind(this, "email")}
          />
          <div className="invalid-feedback">{validation.errors.email}</div>
        </div>
        <div className="form-group">
          <label className="required" htmlFor="phone">Phone</label>
          <PhoneInput
            inputProps={{
              name: "phone",
              className: classnames("form-control", {
                "is-invalid": validation.errors.phone,
              }),
              isValid: !validation.errors.phone
            }}
            onlyCountries={["us"]}
            preferredCountries={["us"]}
            enableAreaCodes={false}
            autoFormat={true}
            inputStyle={{ width: '100%' }}
            placeholder="Enter phone number"
            country='us'
            onlyCountries={['us']}
            onBlur={onFieldValidate.bind(this, "phone")}
            onChange={(newNumber) => onPhoneNumberChange(newNumber)}
            value={user.phone}
          />
          <input
            type="hidden"
            className={classnames("form-control", {
              "is-invalid": validation.errors.phone
            })} />
          <div className="invalid-feedback">{validation.errors.phone}</div>
        </div>
        <div className="actions">
          <button
            className="btn btn-primary bold-button"
            onClick={onPrevious}
          >
            Previous
          </button>
          <button
            className="btn btn-danger bold-button"
            disabled={!validation.valid}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.registration.user,
    validation: state.registration.postEventContactValidation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
    validateField: field => dispatch(postEventContactFieldValidate(field)),
    checkAccountExists: (history) => dispatch(checkAccountExists(history)),
    setRole: (role) => dispatch(setRole(role)),
    contractSubmit: history => dispatch(contractSubmit(history)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostEventContact));
